export default __webpack_public_path__ + "static/media/cars-bg.703346c2.jpg";